
import React from 'react';
import './css/Home.css';

const aboutMe = {
  name: "James Cerniglia",
  github: "jamescer",
  profession: "Software Engineer II",
  skills: ["JavaScript", "Node.js", "Python", "React", "MongoDB", "Kivy"],
  hobbies: [
    "I like animals",
    "I enjoy working out",
    "I love playing video games, especially RuneScape"
  ]
};

const About = () => {
  return (
    <main className="os-main">
      <section className="os-home-card" style={{ maxWidth: 700 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap' }}>
          <img src="./img/me.jpg" alt="James Cerniglia" className="os-pic-of-me" style={{ width: 140, height: 140 }} />
          <div>
            <h1 className="os-title" style={{ marginBottom: '0.5rem' }}>About Me</h1>
            <p className="os-desc"><strong>Name:</strong> {aboutMe.name}</p>
            <p className="os-desc">
              <strong>GitHub:</strong>
              <a
                href={`https://github.com/${aboutMe.github}`}
                target="_blank"
                rel="noopener noreferrer"
                className="os-nav-link"
              >
                {aboutMe.github}
              </a>
            </p>
            <p className="os-desc"><strong>Profession:</strong> {aboutMe.profession}</p>
            <div style={{ margin: '1rem 0' }}>
              <strong>Skills:</strong>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '0.5rem' }}>
                {aboutMe.skills.map((skill, idx) => (
                  <span key={idx} className="badge os-btn" style={{ fontSize: '0.95rem', padding: '4px 12px' }}>{skill}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
        <h2 className="os-title" style={{ fontSize: '1.3rem', marginTop: '2rem' }}>Hobbies</h2>
        <ul style={{ marginLeft: '1rem', marginTop: '1rem' }}>
          {aboutMe.hobbies.map((hobby, index) => (
            <li key={index} className="os-desc" style={{ marginBottom: '10px' }}>{hobby}</li>
          ))}
        </ul>
      </section>
    </main>
  );
};

export default About;
